import { useHasPermission } from "../../auth/useClaims";

// Branch-wise master (handoff §9.6) - Employees.Create/.Edit are separate
// permissions, same pattern as Customers/Products; no all-branch check
// needed, the API already scopes every request to the caller's own
// branch(es) server-side.
export const useCanCreateEmployees = () => useHasPermission("Employees.Create");
export const useCanEditEmployees = () => useHasPermission("Employees.Edit");

// Promotion (POST /{empId}/promote) has its own dedicated permission, split
// off from Employees.Edit (handoff §9.6) - a role can edit regular employee
// fields without being able to promote, and vice versa.
export const useCanPromoteEmployees = () => useHasPermission("Employees.Promote");

// Salary visibility (the per-employee `hide` flag, handoff §9.6). These two
// are independent (a payroll clerk can hold one without the other) and only
// come into play for an employee with hide:true - for the common hide:false
// case, salary is covered by the normal Employees.View/.Edit, no extra gate.
export const useCanViewSalary = () => useHasPermission("Employees.ViewSalary");
export const useCanEditSalary = () => useHasPermission("Employees.EditSalary");
